import { RootState } from "store";
import { StreamingReducerState } from "./streamingSlice";

export const selectStreamingState = (state: RootState): StreamingReducerState =>
  state.streaming;
